import { useTheme } from '@mui/material';
import { type FC, useMemo } from 'react';

import { useSlabQuery } from '@web/hooks/useSlabQuery';

import { buildCompetitorPlantPins } from './mapPins';
import { PinMarkers, type PinMarkersProps } from './PinMarkers';

export const CompetitorPlantMarkers: FC<PinMarkersProps> = (props) => {
  const theme = useTheme();
  const { data: competitorPlants } = useSlabQuery('GET competitor plants', {});

  const pins = useMemo(
    () => buildCompetitorPlantPins(competitorPlants?.items ?? [], theme),
    [competitorPlants, theme],
  );

  return <PinMarkers pins={pins} {...props} />;
};
